import { render, staticRenderFns } from "./delete-confirmation.vue?vue&type=template&id=c30f8916&scoped=true&"
import script from "./delete-confirmation.vue?vue&type=script&lang=js&"
export * from "./delete-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./delete-confirmation.vue?vue&type=style&index=0&id=c30f8916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30f8916",
  null
  
)

export default component.exports